var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnderline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.377 14a.854.854 0 0 1-.623-.25.827.827 0 0 1-.254-.613c0-.242.085-.446.254-.613a.854.854 0 0 1 .623-.25h9.246c.246 0 .454.083.623.25.17.167.254.37.254.613a.827.827 0 0 1-.254.613.854.854 0 0 1-.623.25H1.377zM6 10.83c-1.359 0-2.42-.41-3.186-1.232-.765-.82-1.148-1.914-1.148-3.28V1.067c0-.293.109-.544.327-.753C2.21.104 2.467 0 2.765 0c.297 0 .552.105.765.314.212.21.319.46.319.753v5.337c0 .702.185 1.27.555 1.701.37.432.902.648 1.596.648.694 0 1.225-.216 1.596-.648.37-.432.555-.999.555-1.7V1.066c0-.293.109-.544.327-.753C8.695.104 8.952 0 9.25 0c.297 0 .552.105.765.314.212.21.319.46.319.753v5.25c0 1.367-.383 2.46-1.148 3.281C8.42 10.42 7.359 10.83 6 10.83z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderline);
export default __webpack_public_path__ + "static/media/underline.446fd53e8f58c30b1317b1a8da09101d.svg";
export { ForwardRef as ReactComponent };